// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__EzaVY","content":"Hero_content__F57gH"};